import { Injectable } from '@angular/core';
import { UUID } from 'angular2-uuid';
declare var AW4: any;

import { environment } from '../../environments/environment';

@Injectable()
export class AsperaService {

  sdkLocation = environment.connectUrl
  installer = new AW4.ConnectInstaller({sdkLocation: this.sdkLocation});
  plugin = new AW4.Connect({sdkLocation: this.sdkLocation, minVersion: "3.6.0"});

  launching: boolean = false;
  running: boolean = false;
  session: string;

  constructor() { }

  startSession(onFinish?: () => void) {
    if (this.launching) { return }
    this.launching = true
    if (this.session == null) {
      let statusListener = (eventType: string, status: string) => {this.didUpdateStatus(status, onFinish)};
      this.plugin.addEventListener(AW4.Connect.EVENT.STATUS, statusListener);
      this.session = this.plugin.initSession().app_id;
    } else {
      this.launching = false;
      if (onFinish != null) { onFinish() }
    }
  }

  didUpdateStatus(status: string, onFinish?: () => void) {
    switch(status) {
    case AW4.Connect.STATUS.INITIALIZING:
      this.installer.showLaunching();
      break;
    case AW4.Connect.STATUS.FAILED:
      this.installer.showDownload();
      this.launching = false;
      break;
    case AW4.Connect.STATUS.OUTDATED:
      this.installer.showUpdate();
      this.launching = false;
      break;
    case AW4.Connect.STATUS.RUNNING:
      this.installer.connected();
      this.launching = false;
      this.running = true;
      break;
    default:
      this.launching = false;
      break;
    }

    if (this.launching == false) {
      if (onFinish != null) { onFinish() }
    }
  }

  selectFiles(allowMultiple: boolean = true): Promise<any> {
    return new Promise((resolve,reject) => {
      this.plugin.showSelectFileDialog({
        success: (data) => {
          let files = data.dataTransfer.files.map((file) => {
            let path = file.name;
            file.path = path;
            file.name = this.fileNameFromPath(path);
            file.id = UUID.UUID();
            return file;
          });
          resolve(files);
        },
        error: reject
      }, {
        allowMultipleSelection: allowMultiple
      })
    })
  }

  selectFolders(allowMultiple: boolean = true): Promise<any> {
    return new Promise((resolve,reject) => {
      this.plugin.showSelectFolderDialog({
        success: (data) => {
          let files = data.dataTransfer.files.map((file) => {
            let path = file.name;
            file.path = path;
            file.name = this.fileNameFromPath(path);
            file.id = UUID.UUID();
            return file;
          });
          resolve(files);
        },
        error: reject
      }, {
        allowMultipleSelection: allowMultiple
      })
    })
  }

  fileNameFromPath(path: string): string {
    let splitPath = path.split(/[\\\//]/)
    return splitPath[splitPath.length-1]
  }

  transferFiles(transferSpec: any): Promise<any> {
    transferSpec["authentication"] = "token"
    transferSpec["create_dir"] = true
    let settings = {allow_dialogs: false};
    return new Promise((resolve,reject) => {
      this.plugin.startTransfer(transferSpec, settings, {success: resolve, error: reject})
    })
  }

  addTransferListener(listener: (eventType: string, transferInfo: any) => void) {
    this.plugin.addEventListener(AW4.Connect.EVENT.TRANSFER, listener)
  }

  removeTransferListener(listener: (eventType: string, transferInfo: any) => void) {
    this.plugin.removeEventListener(AW4.Connect.EVENT.TRANSFER, listener)
  }

}



// WEBPACK FOOTER //
// ./src/app/aspera/aspera.service.ts